import { isMatch, isValid } from "date-fns";

export const isValidDate = (date: string) => {
  const dateStr = date;
  if (dateStr?.trim().replace(/[^\d+]/g, '').length !== 8) return false;

  const dateArr = dateStr.split('.');
  let day;
  let month;
  const year = Number(dateArr[2]);

  if (year < (new Date().getFullYear() - 100)) return false;

  let answer = false;
  if (isMatch(dateStr, 'dd.MM.yyyy')) {
    day = Number(dateArr[0]);
    month = Number(dateArr[1])-1;

    answer = isValid(new Date(year, month, day))&&new Date(year, month, day).getTime() < new Date().getTime();
  }

  if (isMatch(dateStr, 'MM.dd.yyyy')) {
    day = Number(dateArr[1]);
    month = Number(dateArr[0])-1;

    answer = isValid(new Date(year, month, day))&&new Date(year, month, day).getTime() < new Date().getTime();
  }

  return answer;
}